import React from 'react';

import { Route, Routes } from "react-router-dom"

import ErrorBoundary from "../components/error/ErrorBoundary";

import ErrorNotFound from "../components/error/ErrorNotFound";
import ErrorBackend from "../components/error/ErrorBackend";

import { default as HomePage } from '../view/InitialPage/HomePage';
import { Step2 } from '../view/InitialPage/Step2';
import { Successful } from '../view/InitialPage/Successful';

const RoutesConfig = () => (

    <Routes>

        <Route
            path={"/alta1a1"}
            exact
            element={<ErrorBoundary><HomePage /></ErrorBoundary>}
        />

        <Route
            path={"/alta1a1/errorBackend"}
            exact
            element={<ErrorBackend />}
        />

        <Route
            path={"/alta1a1/homepage"}
            exact
            element={<ErrorBoundary><HomePage /></ErrorBoundary>}
        />

        <Route
            path={"/alta1a1/step1"}
            exact
            element={<ErrorBoundary><HomePage /></ErrorBoundary>}
        />

        <Route
            path={"/alta1a1/step2"}
            exact
            element={<ErrorBoundary><Step2 /></ErrorBoundary>}
        />

        <Route
            path={"/alta1a1/solicitudexitosa"}
            exact
            element={<ErrorBoundary><Successful /></ErrorBoundary>}
        />

        <Route
            path="*"
            element={<ErrorNotFound/>} />

    </Routes>
);

export default RoutesConfig;
